// Craft and Structure reference sheet — quick-lookup facts and checklists for
// this domain, as opposed to the instructional walkthroughs in the Reading
// and Writing domain guide. Keep entries short: a rule or list, not a
// lesson. Paragraphs are plain strings or structured blocks
// { type: 'steps' | 'list', ... }.

export const documentTitle = 'Craft and Structure Reference';
export const documentSlug = 'craft-and-structure-reference';

export const parts = [
  {
    id: 'craft-structure-reference-full',
    title: null,
    sections: [
      {
        id: 'csr-passage-structures',
        heading: 'Common Passage Structures',
        paragraphs: [
          {
            type: 'list',
            items: [
              'Chronological narrative (events in time order)',
              'Comparison and contrast (two things examined side by side)',
              'Problem and solution',
              'Cause and effect',
              'Claim followed by a counterclaim or rebuttal',
            ],
          },
        ],
      },
      {
        id: 'csr-signal-words',
        heading: 'Contrast vs. Continuation Signal Words',
        paragraphs: [
          {
            type: 'list',
            intro: 'Contrast (the idea that follows works against what came before):',
            items: ['however', 'but', 'although', 'despite', 'yet', 'nevertheless', 'in contrast', 'on the other hand'],
          },
          {
            type: 'list',
            intro: 'Continuation (the idea that follows agrees with or builds on what came before):',
            items: ['and', 'also', 'similarly', 'moreover', 'in addition', 'likewise', 'furthermore'],
          },
        ],
      },
      {
        id: 'csr-words-in-context-method',
        heading: 'Words-in-Context Method',
        paragraphs: [
          {
            type: 'steps',
            steps: [
              'Cover the blank (or the word in question).',
              'Read the sentence and predict your own word from the surrounding logic.',
              "Match your prediction's tone — positive, negative, or neutral — as well as its meaning.",
            ],
          },
        ],
      },
      {
        id: 'csr-cross-text-checklist',
        heading: 'Cross-Text Connection Checklist',
        paragraphs: [
          {
            type: 'steps',
            steps: [
              "State each author's stance in one short phrase.",
              "Decide whether the second author would agree, disagree, or qualify the first author's claim.",
              'Match the answer choice to that relationship, not just to the shared topic.',
            ],
          },
        ],
      },
    ],
  },
];
